import { Image, Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { Translate, TypedTranslate, useI18n } from '@change-corgi/core/react/i18n';

import {
	ActionBar,
	PrimaryActionButton,
	SecondaryActionButton,
} from 'src/app/pages/startAPetitionV2/shared/components';

import { useIntro } from './hooks/useIntro';

const TRANSLATIONS = {
	description: {
		variant: translationKey('corgi.start_a_petition.intro.description_variant'),
		control: translationKey('corgi.start_a_petition.intro.description'),
	},
};

export const Intro: React.FC = () => {
	const { translate } = useI18n();
	const { data, actions } = useIntro();

	return (
		<div
			className="container mx-auto mb-22 flex max-w-155 flex-col gap-6 px-4 py-8 md:gap-12 lg:py-20"
			data-testid="start"
		>
			<picture className="mx-auto">
				<source
					type="image/webp"
					srcSet="https://static.change.org/sap3/hand-holding-plant-1x.webp 1x, https://static.change.org/sap3/hand-holding-plant-2x.webp 2x"
				/>
				<Image
					className="aspect-auto" /* Image component is setting aspect ratio to 16:9 by default */
					src="https://static.change.org/sap3/hand-holding-plant-1x.png"
					srcSet="https://static.change.org/sap3/hand-holding-plant-1x.png 1x, https://static.change.org/sap3/hand-holding-plant-2x.png 2x"
					alt={translate('corgi.start_a_petition.intro.image_alt')}
				/>
			</picture>
			<div>
				<Text as="h1" variant="heading" size="x-large" className="text-center">
					<Translate value="corgi.start_a_petition.intro.heading" />
				</Text>
				<Text as="p" variant="body" size="large" color="sunrise.semantic.typography.weak" className="mt-4 text-center">
					<TypedTranslate value={TRANSLATIONS.description[data.copyVariant]} />
				</Text>
			</div>

			<ActionBar>
				<div className="flex flex-col gap-4">
					{/* eslint-disable @change-corgi/require-data-qa-attribute */}
					<PrimaryActionButton
						className="mx-auto w-full md:max-w-75"
						label={translationKey('corgi.start_a_petition.intro.primary_action_label')}
						onClick={() => actions.submit('with_ai')}
						type="button"
					/>
					<SecondaryActionButton
						variant="tertiary"
						className="mx-auto w-full md:max-w-75"
						label={translationKey('corgi.start_a_petition.intro.secondary_action_label')}
						onClick={() => actions.submit('write_my_own')}
						type="button"
					/>
					{/* eslint-enable @change-corgi/require-data-qa-attribute */}
				</div>
			</ActionBar>
		</div>
	);
};
